import { Component, ElementRef, Input, OnInit, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import * as highcharts from "highcharts";
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-stackedbar-chart',
  templateUrl: './stackedbar-chart.component.html',
  styleUrls: ['./stackedbar-chart.component.scss']
})
export class StackedbarChartComponent implements OnChanges  {
  @Input() data:any
  chartOptions = {}
  highcharts = highcharts
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.plotChart(this.data);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.plotChart(this.data);
    }
  }

  plotChart(data: any): void {
    this.chartOptions = {
      chart: {
        type: 'column',
        height: 250
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: data.categories,
        labels: {
          style: {
            fontSize: '13px',
            fontWeight: 'bold',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: data.y_title,
          style: {
            color: "#595959",
            fontSize: "12px",
          },
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        reversed: true,
        verticalAlign: 'top',
      },
      showInLegend: false,
      plotOptions: {
        series: {
          stacking: 'normal',
        },
      },
      series: data.series,
    };
  }
 
}

